import { render, staticRenderFns } from "./DeleteAdvert.vue?vue&type=template&id=21125671"
import script from "./DeleteAdvert.vue?vue&type=script&lang=js"
export * from "./DeleteAdvert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports